module.exports = "<app-widgets-summary object=$ctrl.route type=route></app-widgets-summary> <app-widgets-review-info-view object=$ctrl.route></app-widgets-review-info-view> <app-widgets-transitions object=$ctrl.route kind=\"'route'\" object-versions=$ctrl.routeVersions></app-widgets-transitions> <app-route-navbar route=$ctrl.route></app-route-navbar> <ui-view></ui-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/component_partial.html
// module id = 498
// module chunks = 0